// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2kGpH","filesListContainer":"PosDisputesFiles_filesListContainer__3We0w","filesButton":"PosDisputesFiles_filesButton__3DlvR"};